import { create } from 'zustand';

/* The popup state type  */
export type CouponPopupState = {
    content: any;
    onClose?: () => void;
    open: (content: any, onClose?: () => void) => void;
    close: () => void;
    isOpen: () => boolean;
    setOnClose: (customOnClose: () => void) => void;
};

/* The initial storage state */
export const initialCouponPopupState = {
    content: undefined,
    onClose: undefined,
};

/* The store that keep informations about the coupon popup */
export const useCouponPopup = create<CouponPopupState>((set: any, get: any) => ({
    ...initialCouponPopupState,
    setOnClose: (customOnClose: () => void) => {
        set((state: CouponPopupState) => ({ ...state, onClose: customOnClose }));
    },
    isOpen: () => {
        const { content } = get();
        return content !== initialCouponPopupState.content;
    },
    open: (content: any, onClose: () => void = () => {}) => {
        set((state: CouponPopupState) => ({ ...state, content, onClose }));
    },
    close: () => {
        const { onClose } = get();
        if (onClose) onClose();
        set({ ...initialCouponPopupState });
    },
}));
